import {skipToken} from '@reduxjs/toolkit/query';
import {DataStatus} from 'platform/components';
import {Show} from 'platform/foundation';

import {useParams} from 'react-router-dom';

import {isNil, isNotNil} from 'ramda';

import {useGetTenantQuery} from '@dms/api/core';
import {useGetCheckoutProfileQuery} from '@dms/api/sales';
import {useGetCurrentBranch} from '@dms/shared';

import {CheckoutProfileEditor} from './components/CheckoutProfileEditor';

export function CheckoutProfileDetail() {
  const {id} = useParams();
  const {activeBranchId} = useGetCurrentBranch();
  const {data: tenant} = useGetTenantQuery();
  const {
    currentData: profile,
    isFetching,
    isError,
  } = useGetCheckoutProfileQuery(isNotNil(id) ? {checkoutProfileId: id} : skipToken);

  return (
    <DataStatus
      isLoading={isNotNil(id) && isNil(profile) && isFetching}
      isError={isError}
      minHeight={60}
    >
      <Show when={isNil(id) || profile}>
        <CheckoutProfileEditor
          key={id ?? 'new'}
          initialProfile={profile}
          branchId={activeBranchId ?? undefined}
          currency={tenant?.currency}
        />
      </Show>
    </DataStatus>
  );
}
